import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import StaticHelpingToolkit from "../CommonToolkit/StaticHelpingToolkit";

function Breadcrumb(props) {
  const { toolkit, toolkitData, currentMenu, mainMenu, subMenu, subSubMenu } =
    props;
  const { t } = useTranslation();
  const [showToolkit, setShowToolkit] = useState(false);
  return (
    <>
      <div className="d-flex justify-content-between align-items-end">
        <div className="d-flex justify-content-end align-items-end gap-1">
          {mainMenu && <h4 className="tx-18 fw-normal">{mainMenu}</h4>}

          {subMenu && (
            <h4 className="tx-18 fw-normal">
              <i className="fa fa-arrow-right"></i> {subMenu}
            </h4>
          )}

          {subSubMenu && (
            <h4 className="tx-18 fw-normal">
              <i className="fa fa-arrow-right"></i> {subSubMenu}
            </h4>
          )}
        </div>
        <div className="d-flex justify-content-end align-items-end">
          {toolkit ? (
            <OverlayTrigger
              placement="left"
              overlay={<Tooltip>{t("Common.Details")}</Tooltip>}
            >
              <h4 className="tx-18" onClick={() => setShowToolkit(true)}>
                {" "}
                <i className="btn m-0 p-0 fas fa-info-circle text-info cursor-pointer"></i>{" "}
                {t("Common.seeHelpingToolkit")}
              </h4>
            </OverlayTrigger>
          ) : (
            <h4 className="tx-18 fw-normal">{currentMenu}</h4>
          )}
        </div>
      </div>
      {showToolkit && (
        <StaticHelpingToolkit
          showToolkit={showToolkit}
          setShowToolkit={setShowToolkit}
          toolkitData={toolkitData}
        />
      )}
    </>
  );
}

export default Breadcrumb;
